import React, { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

export const EmployeeSearchSelect = ({ options, value, onChange, placeholder = "Search employees…", triggerPlaceholder = "Pick an employee", testId }) => {
  const [open, setOpen] = useState(false);
  const selected = options.find((o) => o.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} className="w-full justify-between font-normal" data-testid={testId}>
          <span className={`truncate ${selected ? "" : "text-gray-400"}`}>{selected ? selected.label : triggerPlaceholder}</span>
          <ChevronsUpDown className="ml-2 h-3.5 w-3.5 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder={placeholder} data-testid={testId ? `${testId}-search` : undefined} />
          <CommandList>
            <CommandEmpty>No match.</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem
                  key={o.id}
                  value={`${o.label} ${o.sublabel || ""}`}
                  onSelect={() => { onChange(o.id); setOpen(false); }}
                  data-testid={testId ? `${testId}-option-${o.id}` : undefined}
                >
                  <Check className={`mr-2 h-3.5 w-3.5 shrink-0 ${o.id === value ? "opacity-100" : "opacity-0"}`} />
                  <span className="truncate">{o.label}</span>
                  {o.sublabel && <span className="ml-auto pl-2 text-[10px] text-gray-400 font-mono uppercase shrink-0">{o.sublabel}</span>}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
